// reCAPTCHA call only after token is valid
window.onSubmit = async function (token) {
  const form = document.getElementById('gbBisForm');
  const name = form.gbBisName.value;
  const email = form.gbBisEmail.value;
  const productTitle = form.gbBisProductTitle.value;
  const variantSKU = form.gbBisVariantSKU.value || "none provided";

  const response = await fetch('https://gb-bis-noti-250508.vercel.app/api/back-in-stock', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name,
      email,
      productTitle,
      sku: variantSKU,
      'g-recaptcha-response': token
    })
  });

  const result = await response.json();
  const messageContainer = document.getElementById('gb-bis-message');

  if (response.ok) {
    messageContainer.innerHTML = `<p>${result.message || 'Thanks! Your submission is received.'}</p>`;
  } else {
    messageContainer.innerHTML = `<p>${result.error || 'Oops, something went wrong.'}</p>`;
  }

  form.reset();
};